import { Link } from "react-router-dom";

export const CollectionCard = ({ collection, index = 0 }) => {
  const seasonColors = {
    spring: "bg-spring",
    summer: "bg-summer",
    fall: "bg-fall",
    winter: "bg-winter",
  };

  return (
    <Link
      to={`/collection/${collection.id}`}
      className="group block min-w-[280px] md:min-w-[350px] snap-start animate-fade-in"
      style={{ animationDelay: `${index * 0.1}s` }}
      data-testid={`collection-card-${collection.id}`}
    >
      <div className="relative overflow-hidden">
        <img
          src={collection.cover_image}
          alt={collection.name}
          className="aspect-[4/5] object-cover w-full transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <span className={`inline-block ${seasonColors[collection.season]} px-3 py-1 text-xs uppercase tracking-widest text-foreground mb-3`}>
            {collection.season} {collection.year}
          </span>
          <h3 className="font-serif text-xl md:text-2xl text-white group-hover:text-white/90 transition-colors">
            {collection.name}
          </h3>
        </div>
      </div>
    </Link>
  );
};

export default CollectionCard;
